import { WorkflowHandler } from "./WorkflowHandler";

export class ISiteMobileWorkflowIndexPage {
    constructor() {  }
    public Init() { 
        WorkflowHandler.InitWorkflowButtons();         
    }    
};